import React from "react";
import { number, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { getStoryDate } from "../../utils/utils";

import "./publishedAt.m.css";

const PublishedAt = ({ date, className = "published-at", lang, pageType }) => {
  if (!date) {
    return null;
  }

  return (
    <time
      styleName={`published-at ${lang === "en" ? "en-published-at" : ""}`}
      className={`${className} ${lang === "en" ? "en-published-at" : ""}`}
    >
      {pageType === "video-story" ? getStoryDate(date, lang, "story-page") : getStoryDate(date, lang)}
    </time>
  );
};

PublishedAt.propTypes = {
  date: number,
  className: string,
  lang: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], {}),
});

export default connect(mapStateToProps, null)(PublishedAt);
